<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready">
            <div class="card">
                <div class="card-title flex justify-between">
                    <div>Счет на оплату #{{ entry.external_id }} ({{ entry.order.product.name }})</div>
                    <div
                        class="badge whitespace-no-wrap badge-success"
                        v-if="entry.status == 'paid'"
                    >Оплачен</div>
                    <div
                        class="badge whitespace-no-wrap badge-gray"
                        v-else-if="entry.status == 'pending'"
                    >Ожидает оплаты</div>
                    <div
                        class="badge whitespace-no-wrap badge-warning"
                        v-else-if="entry.status == 'cancelled'"
                    >Отменен</div>
                </div>

                <div class="flex -mx-2">
                    <text-field
                        class="w-1/2 px-2"
                        title="Номер заказа"
                        v-bind:value="entry.order_id"
                        disabled
                    />

                    <text-field
                        class="w-1/2 px-2"
                        title="Внешний ID"
                        v-model="entry.external_id"
                        required
                    />
                </div>

                <div class="flex -mx-2">
                    <text-field
                        class="w-1/2 px-2"
                        title="Стоимость"
                        v-bind:value="entry.amount"
                        disabled
                    />
                </div>

                <div class="flex -mx-2">
                    <text-field
                        class="w-full px-2"
                        title="Ссылка на оплату"
                        v-bind:value="entry.link"
                    />
                </div>

                <button
                    v-clipboard:copy="entry.link"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onCopyError"
                    class="btn btn-primary"
                >Скопировать ссылку</button>

                <hr class="my-3" />

                <div v-if="qrCode" class="w-1/5">
                    <img :src="qrCode" />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";

export default {
    extends: ResourceForm,

    data() {
        return {
            resource: {
                name: "admin.billing.invoices",
                endpoint: "admin/billing/invoices"
            },
            qrCode: ""
        };
    },

    methods: {
        onCopy() {
            this.$message.success(
                "Ссылка на оплату скопирована в буфер обмена"
            );
        },

        onCopyError() {
            this.$message.error("Произошла ошибка");
        },

        getQRCode() {
            axios
                .get("admin/billing/invoices/" + this.entry.id + "/qr")
                .then(response => {
                    this.qrCode =
                        "data:image/svg+xml;base64," +
                        window.btoa(response.data);
                });
        }
    },

    mounted() {
        this.getQRCode();
    }
};
</script>